import { render } from "./AppDialogs.vue?vue&type=template&id=befbc31a&scoped=true&ts=true"
import script from "./AppDialogs.vue?vue&type=script&lang=ts"
export * from "./AppDialogs.vue?vue&type=script&lang=ts"

import "./AppDialogs.vue?vue&type=style&index=0&id=befbc31a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befbc31a"]])

export default __exports__